import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function ChatRedirect() {
  const { openCollaborate } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    openCollaborate();
    navigate('/');
  }, [openCollaborate, navigate]);
  return <p className="text-sm text-gray-500">Opening Collaborate…</p>;
}
